import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { StatusOptions } from './SharedOptions';

export interface VoucherProductRow {
  id: number;
  seq: number;
  status: string;
  provider_name: string;
  offer_title: string;
  reusable_code: string;
  category: string;
  external_url: string;
}

export const VoucherProduct: Entity<VoucherProductRow> = {
  id: 'VoucherProduct',
  title: 'Voucher Product',
  service: 'main',
  rowLabel: (row: VoucherProductRow) => [row.provider_name, row.offer_title].join(', '),
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.voucher_product',
  },
  security: [
    { role: 'all-authed', action: 'read', access: 'all' },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['seq', 'ASC']],
  defaultFilters: [
    { fieldId: 'offer_title', operator: 'sw', value: '' },
    { fieldId: 'status', operator: 'eq', value: 'ACTIVE', display: 'hidden' },
  ],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
      visible: false,
    },
    seq: {
      seq: 10,
      type: FieldType.Integer,
      label: 'Sequence',
      listColumn: true,
    },
    status: {
      seq: 15,
      type: FieldType.Options,
      label: 'Status',
      listColumn: true,
      mandatory: true,
      options: StatusOptions,
    },
    provider_name: {
      seq: 20,
      type: FieldType.Text,
      label: 'Provider Name',
      listColumn: true,
      mandatory: true,
      maxLength: 80,
    },
    offer_title: {
      seq: 25,
      type: FieldType.Text,
      label: 'Offer Title',
      listColumn: true,
      mandatory: true,
      maxLength: 255,
    },
    reusable_code: {
      seq: 30,
      type: FieldType.Text,
      label: 'Reusable Code',
      description: 'If supplied, VoucherCode entity is ignored, otherwise there must be codes in VoucherCode',
      listColumn: true,
      maxLength: 40,
    },
    category: {
      seq: 35,
      type: FieldType.Text,
      label: 'Category',
      listColumn: true,
      maxLength: 80,
    },
    external_url: {
      seq: 40,
      type: FieldType.Text,
      label: 'External Url',
      mandatory: true,
      maxLength: 1000,
    },
  },
};
